<template>
  <v-card class="pa-4 px-6" flat>
    <div class="d-flex align-center">
      <h3>SKU's mais vendidos</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click="excel"><v-icon>mdi-download</v-icon></v-btn>
    </div>

    <v-divider class="ma-2"></v-divider>

    <v-data-table
      :items="items"
      :loading="loading"
      :headers="headers"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="pageCount"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";
export default {
  name: "Skus",
  components: {Pagination},

  props: {
    filter: Object,
  },

  created() {
    this.list();
  },

  data() {
    return {
      pageCount: 1,
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
      items: [],
      loading: false,
      apiService: new ApiService(),
      headers: [
        {
          text: "Produto",
          value: "product",
        },
        {
          text: "Atributo",
          value: "attribute",
        },
        {
          text: "Vendas (Quantidade)",
          value: "salesCount",
        },
        {
          text: "Vendas (Contábil)",
          value: "salesValue",
        },
      ],
      page: 1,
    };
  },

  methods: {
    list() {
      this.loading = true;

      this.apiService
        .post(
          "dashboard/skus",
          { ...this.filter, page: this.page },
          false,
        )
        .then((response) => {
          this.items = response.content.data;
          this.pageCount = response.content.pager.totalPages;
          this.totalItems = response.content.pager.totalItems;
          this.currentPage = response.content.pager.currentPage;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.page += 1;
      await this.list();
    },

    excel() {
      this.loading = true;

      this.apiService
        .post(
          "dashexport/skus",
          { ...this.filter, page: this.page },
          false,
          false,
          false
        )
        .then((response) => {
          const excel =
            "data:application/octet-stream;base64," + response.content;
          const link = document.createElement("a");
          link.href = excel;
          link.setAttribute("download", `skus.xlsx`);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.list();
      },
    },
  },
};
</script>

<style></style>
